import Glide from '@glidejs/glide';

// const animationDuration = 3000;

function initializeWorkWith() {
  const components = document.querySelectorAll(
    '.wp-block-ath-work-with-carousel'
  );

  components.forEach((component) => {
    initializeGlide(component);
  });
}

function initializeGlide(el) {
  const glide = el.querySelector('.glide');
  const numberOfSlides = glide.querySelector('ul').childElementCount;

  if (glide && numberOfSlides > 1)
    return new Glide(glide, {
      type: 'carousel',
      autoplay: 2000,
      gap: 25,
      perView: 5,
    }).mount();
}

export { initializeWorkWith };
